import React from "react";
import ReactDOM from "react-dom";
import {createBrowserHistory} from "history";
// import {Router, Route, Switch, Redirect} from "react-router-dom";
import {Router, Route, Switch } from "react-router-dom";
import {Provider} from "mobx-react";
import {rehydrate, hotRehydrate} from "rfx-core";
import {isProduction, isStage} from "./utils/constants";
// import stores from "./stores/stores"; //app need it to load the mobx store

import indexRoutes from "./routes/index";

import "./assets/scss/material-dashboard-pro-react.css?v=1.1.1";

const hist = createBrowserHistory();
const store = rehydrate();

ReactDOM.render(
    <Router history={hist}>
        <Provider store={isProduction || isStage ? store : hotRehydrate()}>
            <Switch>
                {
                    indexRoutes.map((prop, key) => {
                        return <Route path={prop.path} component={prop.component} key={key}/>;
                    })
                }
            </Switch>
        </Provider>
    </Router>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js